
import React from 'react';
import { TextField, Toggle } from 'redux-form-material-ui';
import * as Institution from '../constants/Institution';
import { Field } from 'redux-form';

const styles = {
  formTextStyle: {
    width: '800px',
  },
  // フォーム内の薄い文字.
  floatingLabelStyle: {
    color: '#999',
  },
  // デフォルトのトグルの横幅が広いため調整.
  toggleStyle: {
    width: '220px',
  },
}

// 一旦クローン.
const copiedModel = Object.assign({}, Institution.Model);
const newModel = Object.assign(copiedModel, {
  // 微妙に違うため.
  "iPadCode": "iPad初期パスコード",
  "password": "パスワード",
});
// 利用者on/off消す.
delete newModel['enabled']

// 新規時の各フィールド.
// バリデーションや初期値はcontainers/InstitutionCreateForm.jsのコンテナで行う.
export const institutionNewField = Object.keys(newModel).map((key) => {
  // 編集不可.
  let readOnly = false;
  if (['institution_care_id', 'password'].includes(key)) {
    readOnly = true;
  }

  if (key !== "id") {
    return (
      <div key={key}>
        <Field
          key={key}
          name={key}
          component={TextField}
          hintText={newModel[key]}
          floatingLabelText={newModel[key]}
          style={styles.formTextStyle}
          floatingLabelStyle={styles.floatingLabelStyle}
          readOnly={readOnly}
        />
      </div>
    );
  } else {
    return (
      <div></div>
    );
  }
});

// 新規登録時のプレビュー画面.
export const institutionNewPreviewField = Object.keys(newModel).map((key) => {
  if (key !== "id") {
    return (
      <div key={key}>
        <Field
          key={key}
          name={key}
          component={TextField}
          // アンダーラインを消す
          underlineStyle={{display: 'none'}}
          hintText={newModel[key]}
          floatingLabelText={newModel[key]}
          style={styles.formTextStyle}
          readOnly={true}
        />
      </div>
    );
  } else {
    return (
      <div></div>
    );
  }
});

/**
 * バリデーションや初期値はcontainers/InstitutionUpdateForm.jsのコンテナで行う.
 * 編集時の各フィールド.
 *
 * @param {*} enabled ユーザーの有効・無効の切り替え.
 * @returns
 */
export const institutionField = (enabled) => {
  return Object.keys(Institution.Model).map((key) => {
    // 編集不可.
    let disabled = false;
    if (['institution_id', 'application_year_month', 'institution_care_id'].includes(key)) {
      disabled = true;
    }

    if (key !== "id") {
      // 「ユーザーの有効・無効」はトグル.
      if (key === "enabled") {
        return (
          <div key={key}>
            <table>
              <tr>
                <td>
                  <Field
                    key={key}
                    name={key}
                    component={Toggle}
                    label={Institution.Model[key]}
                    style={styles.toggleStyle}
                    disabled={disabled}
                  />
                </td>
                <td>
                  <div>{enabled ? '有効' : '無効'}</div>
                </td>
              </tr>
            </table>
          </div>
        );
      } else {
        return (
          <div key={key}>
            <Field
              key={key}
              name={key}
              component={TextField}
              hintText={Institution.Model[key]}
              floatingLabelText={Institution.Model[key]}
              style={styles.formTextStyle}
              floatingLabelStyle={styles.floatingLabelStyle}
              disabled={disabled}
            />
          </div>
        );
      }
    } else {
      return (
        <div></div>
      );
    }
  });
};

/**
 * 編集時のプレビュー画面.
 *
 * @param {*} enabled ユーザーの有効・無効の切り替え.
 * @param {*} disabled 確認面は「ユーザーの有効・無効」を変更不可能(true)、更新後は変更可能(false).
 * @returns
 */
export const institutionPreviewField = (enabled, disabled) => {
  return Object.keys(Institution.Model).map((key) => {
    if (key !== "id") {
      // 「ユーザーの有効・無効」はトグル.
      if (key === "enabled") {
        return (
          <div key={key}>
            <table>
              <tr>
                <td>
                  <Field
                    key={key}
                    name={key}
                    component={Toggle}
                    label={Institution.Model[key]}
                    style={styles.toggleStyle}
                    // 有効・無効.
                    disabled={disabled}
                  />
                </td>
                <td>
                  <div>{enabled ? '有効' : '無効'}</div>
                </td>
              </tr>
            </table>
          </div>
        );
      } else {
        return (
          <div key={key}>
            <Field
              key={key}
              name={key}
              component={TextField}
              // アンダーラインを消す
              underlineStyle={{display: 'none'}}
              hintText={Institution.Model[key]}
              style={styles.formTextStyle}
              floatingLabelText={Institution.Model[key]}
              readOnly={true}
            />
          </div>
        );
      }
    } else {
      return (
        <div></div>
      );
    }
  });
};



// WEBPACK FOOTER //
// ./src/components/InstitutionField.js